import { React, useEffect, useState, useRef } from "react";
import TextField from '@mui/material/TextField';

function RiskQuestion({value, onChange, label}) {

    const [textValue, setTextValue] = useState("");
    let updateTimeout = useRef(null)
    let currentText = useRef(null)

    function onKeyDown(e){

        currentText.current = e.currentTarget.value
        setTextValue(currentText.current)
       
        if(updateTimeout.current){
            clearTimeout(updateTimeout.current);
        }

        updateTimeout.current = setTimeout(() => {
            onChange(currentText.current)
            updateTimeout.current = null;
        }, 50);

    }

    useEffect(() => {
        if(JSON.stringify(value) !== JSON.stringify(textValue)){
            setTextValue(value)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[value])

    return (
        <>
        
            <TextField id="standard-basic" variant="standard"
                className={`form_input`}
                fullWidth
                multiline
                cols={50}
                rows={4}
                value={textValue}
                onChange={onKeyDown}
                InputLabelProps={{ style: { zIndex:2 } }}
                label={label}

            />
        
        </>
    )
                            

}
export default RiskQuestion